import { LANGUAGE_REGISTRY, type Lang } from "../languageRegistry";

/**
 * English labels for Gemini prompts and the gemini Cloud Function `lang` field.
 * Derived from `LANGUAGE_REGISTRY` (single source of truth).
 */
export const GEMINI_LANG_LABEL_ENGLISH = Object.fromEntries(
  (Object.keys(LANGUAGE_REGISTRY) as Lang[]).map((k) => [
    k,
    LANGUAGE_REGISTRY[k].geminiEnglishLabel,
  ]),
) as Record<Lang, string>;

/**
 * Human-readable English label for user-facing prompts.
 */
export function getGeminiLangLabelForPrompt(code: string | undefined): string {
  const trimmed = typeof code === "string" ? code.trim() : "";
  if (!trimmed) return GEMINI_LANG_LABEL_ENGLISH.en;
  return GEMINI_LANG_LABEL_ENGLISH[trimmed as Lang] ?? trimmed;
}

/**
 * Value sent in the gemini HTTP JSON body as `lang` (system prompts).
 */
export function resolveLangForGeminiHttp(
  raw: string | undefined,
): string | undefined {
  const trimmed = typeof raw === "string" ? raw.trim() : "";
  if (!trimmed) return undefined;
  const entry = LANGUAGE_REGISTRY[trimmed as Lang];
  if (entry) return entry.geminiEnglishLabel;
  return trimmed;
}
